import ajax from '../../lib/ajax'

// GetOraganizationList
// 获取组织列表
export async function GetOraganizationList(payload:any) {
    let res = await ajax.get('api/services/app/Organization/GetOraganizationList',{params:payload},false)
    return res.data.result
}
// GetOrgDepartmentInfo
// 获取部门详情
export async function GetOrgDepartmentInfo(payload:any) {
    let res = await ajax.get('api/services/app/Organization/GetOrgDepartmentInfo',{params:payload},false)
    return res.data.result
}
// GetOrgDepartmentList
// 获取部门列表
export async function GetOrgDepartmentList(payload:any) {
    let res = await ajax.get('api/services/app/Organization/GetOrgDepartmentList',{params:payload},false)
    return res.data.result
}
// GetPositionList
// 获取职位列表
export async function GetPositionList(payload:any) {
    let res = await ajax.get('api/services/app/Organization/GetPositionList',{params:payload},false)
    return res.data.result
}
// GetPosititonInfo
// 获取职位详情
export async function GetPosititonInfo(payload:any) {
    let res = await ajax.get('api/services/app/Organization/GetPosititonInfo',{params:payload},false)
    return res.data.result
}
// GetDepartMentTypeList
// 获取部门类型列表
export async function GetDepartMentTypeList(payload:any) {
    let res = await ajax.get('api/services/app/Organization/GetDepartMentTypeList',{params:payload},false)
    return res.data.result
}
// GetOrganizationList
// 获取组织列表
export async function GetOrganizationList(payload:any) {
    let res = await ajax.get('api/services/app/Organization/GetOrganizationList',{params:payload},false)
    return res.data.result
}
// GetOrgDepartmentDropDownList
// 根据组织ID获取部门列表
export async function GetOrgDepartmentDropDownList(payload:any) {
    let res = await ajax.get('api/services/app/Organization/GetOrgDepartmentDropDownList',{params:payload},false)
    return res.data.result
}
// DeleteOrganization
// 删除组织
export async function DeleteOrganization(payload:any) {
    let res = await ajax.delete('api/services/app/Organization/DeleteOrganization',{params:payload},false)
    return res.data.result
}
// CreateOrganization
// 新增组织
export async function CreateOrganization(payload:any) {
    let res = await ajax.post('api/services/app/Organization/CreateOrganization', payload,false)
    return res.data.result
}
// CreateOrgDepartment
// 新增部门
export async function CreateOrgDepartment(payload:any) {
    let res = await ajax.post('api/services/app/Organization/CreateOrgDepartment', payload,false)
    return res.data.result
}
// CreatePosition
// 新增职位
export async function CreatePosition(payload:any) {
    let res = await ajax.post('api/services/app/Organization/CreatePosition', payload,false)
    return res.data.result
}
// UpdateOrgDepartment
// 更新部门
export async function UpdateOrgDepartment(payload:any) {
    let res = await ajax.put('api/services/app/Organization/UpdateOrgDepartment', payload,false)
    return res.data.result
}
// UpdatePosition
// 更新职位
export async function UpdatePosition(payload:any) {
    let res = await ajax.put('api/services/app/Organization/UpdatePosition', payload,false)
    return res.data.result
}
// UpdateOrganization
// 更新组织
export async function UpdateOrganization(payload:any) {
    let res = await ajax.put('api/services/app/Organization/UpdateOrganization', payload,false)
    return res.data.result
}